// extracted by mini-css-extract-plugin
export default {"container":"about_container__wJ7m7","desc":"about_desc__GWEjx","images":"about_images__FVVBX","title":"about_title__Px59+","image":"about_image__2HGde"};